module.exports = __webpack_public_path__ + "img/speech_bubble_question_mark.825b01a7.svg";